// TODO add overlay and default image to tehse
export const IMAGE_FIELDS = `//groq
  _type,
  asset,
  "altText": coalesce(altText, alt, ""),
  "border": coalesce(border, false),
  "caption": coalesce(caption, ''),
  defaultImage,
  hotspot,
  overlay,
  noFollow,
  "fullWidth": coalesce(fullWidth, false),
  "floatLeft": coalesce(floatLeft, false),
  "floatRight": coalesce(floatRight, false),
  "internalLink": internalLink->{"s": slug.current}.s,
  "link": coalesce(link, ""),
  "newTab": coalesce(newTab, false),
  "ratio": @.asset->{metadata}.metadata{dimensions}.dimensions{width}.width / @.asset->{metadata}.metadata{dimensions}.dimensions{height}.height,
  "width": @.asset->{metadata}.metadata{dimensions}.dimensions{width}.width,
  "height": @.asset->{metadata}.metadata{dimensions}.dimensions{height}.height,
  "lqip": @.asset->{metadata}.metadata{lqip}.lqip`;

export const CLOUDINARY_ASSET_FIELDS = `//groq
  "_type": asset._type,
  "_key": asset._key,
  asset,
  "altText": coalesce(altText, alt, ""),
  "border": coalesce(border, false),
  "caption": coalesce(caption, ''),
  defaultImage,
  overlay,
  noFollow,
  "fullWidth": coalesce(fullWidth, false),
  "floatLeft": coalesce(floatLeft, false),
  "floatRight": coalesce(floatRight, false),
  "internalLink": internalLink->{"s": slug.current}.s,
  "link": coalesce(link, ""),
  "newTab": coalesce(newTab, false),
  "ratio": asset.width / asset.height,
  "width": asset.width,
  "height": asset.height,
`;

export const PRODUCT_VARIANT_FIELDS = `//groq
  ...,
  "images": coalesce(images[]{
    @.asset._type == "cloudinary.asset" => {
      ${CLOUDINARY_ASSET_FIELDS}
    },
    @._type == "image" => {
      ${IMAGE_FIELDS}
    },
  }, []),
  "optionTags": coalesce(optionTags[], []),
  "options": coalesce(options[], []),
  "scheduledDatetimeAll": coalesce(scheduledDatetimeAll, '1970-01-01T00:00:00.000Z'),
  "scheduledDatetimeBanter": coalesce(scheduledDatetimeBanter, '1970-01-01T00:00:00.000Z'),
  "scheduledDatetimeLoggedIn": coalesce(scheduledDatetimeLoggedIn, '1970-01-01T00:00:00.000Z'),
`;

export const PRODUCT_VARIANTS_FIELDS = `//groq
  coalesce(variants[]->{
    ${PRODUCT_VARIANT_FIELDS}
  }, [])
`;

export const BASE_PRODUCT_FIELDS = `//groq
  "averageRating": coalesce(averageRating, 0),
  addToCartMessage,
  "defaultVariantId": coalesce(defaultVariant->{variantId}.variantId, 0),
  "discontinued": coalesce(discontinued, false),
  "entityId": productId,
  "images": images[]{
    _type == "image" => @{
      ${IMAGE_FIELDS}
    },
    _type == "cloudinaryAsset" => @{
      ${CLOUDINARY_ASSET_FIELDS}
    },
  },
  "maxPurchaseQty": coalesce(maxPurchaseQty, 9999),
  "minPurchaseQty": coalesce(minPurchaseQty, 1),
  "name": title,
  pricePerServe,
  shortDescription,
  "shortName": shortTitle,
  sku,
  "slug": slug.current,
  "tags": coalesce(tags[]->{
    title,
    "parent": parent->{title}.title
  }, []),
  tgaStatement,
  "totalReviews": coalesce(totalReviews, 0),
  "variants": ${PRODUCT_VARIANTS_FIELDS},
`;

export const CUSTOM_FORM_FIELDS = `//groq
  "_type": "customForm",
  title,
  "loggedInOnly": coalesce(loggedInOnly, false),
  "uniqueEntry": coalesce(uniqueEntry, false),
  "fieldsets": fieldsets[] {
    _key,
    title,
    "inputs": inputs[] {
      _key,
      _type == "formInput" => @{
        _type,
        "name": select(name == "other" => nameOther, name),
        label,
        placeholder,
        type,
        "options": options[]{
          label,
          "value": coalesce(value, label),
        },
        "randomiseOptions": coalesce(randomiseOptions, false),
        "validation": validation {
          "required": coalesce(required, false),
          minLength, 
          maxLength, 
          "min": minValue, 
          "max": maxValue,
        }
      },
      _type == "content" => @{
        _type,
        content[]{
          ...,
          markDefs[]{
            ...,
            _type == "internalLink" => {
              "slug": @.item->slug,
            } 
          },
          _type == "cloudinaryAsset" => @{
              ${CLOUDINARY_ASSET_FIELDS}
          },
          _type == "imageSet" => @{
            _key,
            _type,
            width,
            images[]{
              _type == "image" => {
                ${IMAGE_FIELDS}
              },
              _type == "cloudinaryAsset" => {
                ${CLOUDINARY_ASSET_FIELDS}
              },
            }
          },
        }
      },
    },
  },
  "emails": emails[]{
    recipient,
    postmarkTemplateId,
    replyToFormField,
    "replyToCS": coalesce(replyToCS, false),
  },
  _id
`;

export const FORM_FIELDS = `//groq
_type == "form" => @->{
  _type == "customForm" => @{
    ${CUSTOM_FORM_FIELDS}
  },
  _type == "form" => @{
    title,
    formType,
    klaviyoFormId,
    shortStackFormId,
    shortStackV2FormId,
    shortStackFormHeight
  },
},
`;

export const AUTHOR = `//groq
"author": author->{
  name,
  "slug": slug.current,
  "image": select(image.asset._type == "reference" => image{
    ${IMAGE_FIELDS}
  }, image.asset._type == "cloudinary.asset" => image{
    ${CLOUDINARY_ASSET_FIELDS}
  }),
  singleLineDescription,
  shortDescription,
  ambassador,
  facebook,
  instagram,
  twitter,
  tiktok,
  linkedIn,
  website,
  youTube,
  "noFollow": coalesce(noFollow, false),
  "profilePage": coalesce(profilePage, true),
}`;

export const BLOG_TILE_FIELDS = `//groq
  // "numberOfCharacters": length(pt::text(body)),
  // assumes 5 characters as mean word length
  // https://ux.stackexchange.com/questions/22520/how-long-does-it-take-to-read-x-number-of-characters
  // "estimatedWordCount": round(length(pt::text(body)) / 5),
  // Words per minute: 180
  "estimatedReadingTime": round(round(length(pt::text(body)) / 5) / 180),
  "featuredImage": select(
    featuredImage.asset._type == "cloudinary.asset" => featuredImage{
      ${CLOUDINARY_ASSET_FIELDS}
    },
    featuredImage._type == "image" => featuredImage{
      ${IMAGE_FIELDS}
    },
  ),
  ${AUTHOR},
  // Only get the difficultyLevel of the 1st recipe
  "difficultyLevel": body[_type == "recipe"][0].difficultyLevel,
  "category": coalesce(category, ""),
  "slug": slug.current,
  title,
  scheduledDatetime,
`;

/**
 * Handles various types of:
 * carousel, image, cloudinaryAsset, imageSet, form, yotpoGallery, socialLinks, yotpoReviewCarousel,
 * insertAside, message, warning, faq, recommendedProduct
 * and also handles markDefs for internalLink
 */
export const PORTABLE_TEXT_FIELDS = `//groq
  ...,
  _type == "carousel" => @{
    ...,
    "items": items[]->{
      // Ths is the BASE_PRODUCT_FIELDS but compiler bugged
      _type == "product" => @{
        _type,
        ${BASE_PRODUCT_FIELDS}
      },
      _type == "blogPost" => @{
        _type,
        ${BLOG_TILE_FIELDS}
      },
    }
  },
  _type == "image" => @{
    ${IMAGE_FIELDS}
  },
  _type == "cloudinaryAsset" => @{
    ${CLOUDINARY_ASSET_FIELDS}
  },
  _type == "imageSet" => @{
    _key,
    _type,
    width,
    images[]{
      _type == "image" => {
        ${IMAGE_FIELDS}
      },
      _type == "cloudinaryAsset" => {
        ${CLOUDINARY_ASSET_FIELDS}
      },
    }
  },
  _type == "muxVideo" => @{
    "playbackId": video.asset->playbackId,
    altText,
  },
  ${FORM_FIELDS}
  _type == "yotpoGallery" => @->{galleryId},
  _type == "socialLinks" => @{..., "noFollow": coalesce(noFollow, false), "name": ^.^.^.name},
  _type == "yotpoReviewCarousel" => {
    count,
    showBottomLine,
    autoplay,
    autoplaySpeed,
    showNavigation,
    "productId": ^.^.productId
  },
  _type == "insertAside" => @->{
    ...,
    "content": content[]{
      ...,
      _type == "cloudinaryAsset" => @{
        ${CLOUDINARY_ASSET_FIELDS}
      },
      _type == "imageSet" => @{
        _key,
        _type,
        width,
        images[]{
          _type == "image" => {
            ${IMAGE_FIELDS}
          },
          _type == "cloudinaryAsset" => {
            ${CLOUDINARY_ASSET_FIELDS}
          },
        }
      },
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.item->slug,
        }
      } 
    }
  },
  _type == "message"  || _type == "warning" => {
    ...,
    "content": content[]{
      ...,
        markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.item->slug,
        }
      } 
    }
  },
  _type == "faq" => {
    ...,
    "answer": answer[]{
      ...,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "slug": @.item->slug,
        }
      }
    }
  },
  _type == "recommendedProduct" => {
    ...,
    "product": product->{
      ...,
      "parent": *[_type == "product" && productId == ^.productId && siteHidden != true][0]{
        title,
        "slug": slug.current,
        "image": images[defaultImage][0]{
          _type == "image" => {
            ${IMAGE_FIELDS}
          },
          _type == "cloudinaryAsset" => {
            ${CLOUDINARY_ASSET_FIELDS}
          },
        },
        "minPurchaseQty": coalesce(minPurchaseQty, 1),
        "maxPurchaseQty": coalesce(maxPurchaseQty, 9999),
      }
    }
  },
  _type == "columns" => @{
    ...,
    content[]{
      ...,
      contentBody[]{
        ...,
        _type == "carousel" => @{
          ...,
          "items": items[]->{
            _type == "product" => @{
              _type,
              ${BASE_PRODUCT_FIELDS}
            },
            _type == "blogPost" => @{
              _type,
              ${BLOG_TILE_FIELDS}
            },
          }
        },
        _type == "image" => @{
          ${IMAGE_FIELDS}
        },
        _type == "cloudinaryAsset" => @{
          ${CLOUDINARY_ASSET_FIELDS}
        },
        _type == "imageSet" => @{
          _key,
          _type,
          width,
          images[]{
            _type == "image" => {
              ${IMAGE_FIELDS}
            },
            _type == "cloudinaryAsset" => {
              ${CLOUDINARY_ASSET_FIELDS}
            },
          }
        },
        _type == "form" => @->{title, formType, klaviyoFormId, shortStackFormId, shortStackV2FormId, shortStackFormHeight},
        "answer": answer[]{
          ...,
          markDefs[]{
            ...,
            _type == "internalLink" => {
              "slug": @.item->slug,
            } 
          }
        },
        markDefs[]{
          ...,
          _type == "internalLink" => {
            "slug": @.item->slug,
          } 
        },
      }
    }   
  },
  markDefs[]{
    ...,
    _type == "internalLink" => {
      "slug": @.item->slug,
    }
  }
`;
